module.exports = __webpack_public_path__ + "static/Grupo 78-7341df1e332e35f600ad44697200a2da.svg";